import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {ApiResponseModel, ReadingModel} from '../../../../entities/entities'
import HealthCriticalityAlertsTable from '../../components/notifications/HealthCriticalityAlertsTable'
import {useNavigate} from 'react-router-dom'
import MetaTags from '../../../../meta/MetaTags'

const HealthCriticalityAlerts = () => {
  const [healthAlerts, setHealthAlerts] = useState<ReadingModel[]>([])
  const [filteredHealthAlerts, setFilteredHealthAlerts] = useState<ReadingModel[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [sortBy, setSortBy] = useState<string>('all') // default is 'severity'
  const [loadingRowId, setLoadingRowId] = useState<number | null>(null)

  const navigate = useNavigate()

  const handleGeneralHealthAlerts = () => {
    navigate(`/health-alerts/settings`)
  }

  const handleSortByFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value
    setSortBy(selectedValue)
  }

  const sortHealthAlerts = (alerts: ReadingModel[], sort: string) => {
    if (sort === 'all') {
      return alerts
    }
    return alerts.filter((alert) => alert?.bp_category === sort)
  }

  const fetchHealthCriticalityAlerts = async () => {
    setIsLoading(true)
    try {
      const response = await axios.get<ApiResponseModel<{alerts: ReadingModel[]}>>(
        API_ENDPOINTS.GET_HEALTH_ALERTS('')
      )
      const allHealthAlerts = response.data?.data?.alerts || []
      setHealthAlerts(allHealthAlerts)
      // Always apply current filter after fetch
      const filtered = sortHealthAlerts(allHealthAlerts, sortBy)
      setFilteredHealthAlerts(filtered)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message ?? 'Something went wrong')
      } else if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('An unexpected error occurred')
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchHealthCriticalityAlerts()
  }, [])

  useEffect(() => {
    const filtered = sortHealthAlerts(healthAlerts, sortBy)
    setFilteredHealthAlerts(filtered)
  }, [sortBy, healthAlerts])
  const handleChangeReviewedStatus = async (id?: string | number) => {
    if (!id) return
    
    setLoadingRowId(Number(id))
    try{
      await axios.get(
        API_ENDPOINTS.GET_HEALTH_ALERT_REVIEWED(id)
      )
      // fetch updated alerts
      fetchHealthCriticalityAlerts()
    }
    catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      } else if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('An unexpected error occurred')
      }
    } finally {
      setLoadingRowId(null)
    }
  }
  return (
    <>
      <MetaTags title={'Health Criticality Alerts'} />
      <div className='d-flex justify-content-end p-2 me-4'>
        <button className='btn bg-purple text-white fw-bold' onClick={handleGeneralHealthAlerts}>
          General Health Alerts
        </button>
      </div>
      <div>
        <HealthCriticalityAlertsTable
          loading={isLoading}
          healthAlerts={filteredHealthAlerts}
          title={'Health Criticality Alerts'}
          onReload={() => fetchHealthCriticalityAlerts()}
          sortByFilter={sortBy}
          handleSortByFilter={handleSortByFilterChange}
          handleReviewToggle={handleChangeReviewedStatus}
          loadingRowId={loadingRowId}
        />
      </div>
    </>
  )
}
export default HealthCriticalityAlerts
